import {useState} from 'react';
import {TextField, Button, CircularProgress, Typography} from '@mui/material';
import {collection, addDoc, Timestamp} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import {db, storage } from '../../../firebase/firebase';

import {Grid} from "@mui/material";

const Formulario_Crear_Proyectos = () => {
    const [title, setTitle] = useState('');
    const [sitio, setSitio] = useState('');
    const [anio, setAnio] = useState('');
    const [cliente, setCliente] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [images, setImages] = useState([]);
    const [compareImages, setCompareImages] = useState([]); // ⬅️ NUEVO
    const [loading, setLoading] = useState(false);

    const handleImageChange = (e) => {
        setImages(Array.from(e.target.files));
    };

    // máximo 2 imágenes para comparar (antes/después)
    const handleCompareImageChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (files.length > 2) {
            // Tomamos las primeras 2 para evitar errores
            setCompareImages(files.slice(0, 2));
            alert('Solo se usarán las primeras 2 imágenes para "Antes / Después".');
        } else {
            setCompareImages(files);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación completa: todos los campos obligatorios + imágenes de galería + 2 imágenes para comparar
        if (
            !title.trim() ||
            !sitio.trim() ||
            !anio.trim() ||
            !cliente.trim() ||
            !descripcion.trim() ||
            images.length === 0 ||
            compareImages.length !== 2
        ) {
            alert('Completa todos los campos, incluyendo las 2 imágenes de Antes / Después.');
            return;
        }

        setLoading(true);
        try {
            // Subir imágenes de galería
            const imageUrls = await Promise.all(
                images.map(async (image) => {
                    const imageRef = ref(storage, `blog_images/${Date.now()}_${image.name}`);
                    await uploadBytes(imageRef, image);
                    return await getDownloadURL(imageRef);
                })
            );

            // Subir imágenes de comparación (exactamente 2)
            const compareImageUrls = await Promise.all(
                compareImages.map(async (image) => {
                    const imageRef = ref(storage, `compare_images/${Date.now()}_${image.name}`);
                    await uploadBytes(imageRef, image);
                    return await getDownloadURL(imageRef);
                })
            );

            await addDoc(collection(db, 'proyectos'), {
                title,
                sitio,
                anio,
                cliente,
                descripcion,
                images: imageUrls,
                compareImages: compareImageUrls,
                createdAt: Timestamp.now(),
            });

            alert('Publicado con éxito');

            // Resetear campos
            setTitle('');
            setSitio('');
            setAnio('');
            setCliente('');
            setDescripcion('');
            setImages([]);
            setCompareImages([]);
        } catch (err) {
            console.error('❌ Error escribiendo en Firestore:', err);
            alert('Error publicando');
        } finally {
            setLoading(false);
        }
    };
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 11}}>

            <Grid  component="form" onSubmit={handleSubmit} container size={{xs: 12, sm: 12, md: 11}}
                   sx={{maxWidth: 500, px: 3, pt:10}}>

                <TextField
                    label="Nombre del proyecto"
                    fullWidth
                    margin="normal"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <TextField
                    label="Sitio "
                    fullWidth
                    rows={5}
                    margin="normal"
                    value={sitio}
                    onChange={(e) => setSitio(e.target.value)}
                />
                <TextField
                    label="Año"
                    fullWidth
                    rows={5}
                    margin="normal"
                    value={anio}
                    onChange={(e) => setAnio(e.target.value)}
                />
                <TextField
                    label="Cliente"
                    fullWidth
                    rows={5}
                    margin="normal"
                    value={cliente}
                    onChange={(e) => setCliente(e.target.value)}
                />
                <TextField
                    label="Descripción"
                    fullWidth
                    multiline
                    rows={5}
                    margin="normal"
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                />

                <Grid container spacing={2} sx={{ my: 2 }} size={{xs: 12, sm: 12, md: 12}}>
                    <Grid size={{xs: 12, sm: 12, md: 6}}>
                        <Button
                            component="label"
                            variant="outlined"
                            fullWidth
                        >
                            Subir imágenes
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                multiple
                                onChange={handleImageChange}
                            />
                        </Button>
                        {images.length > 0 && (
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {images.length} imagen(es) de galería seleccionadas
                            </Typography>
                        )}
                    </Grid>

                    <Grid size={{xs: 12, sm: 12, md: 6}}>
                        <Button
                            component="label"
                            variant="outlined"
                            fullWidth
                        >
                            Antes / Después (máx. 2)
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                multiple
                                onChange={handleCompareImageChange}
                            />
                        </Button>
                        {compareImages.length > 0 && (
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {compareImages.length} imagen(es) para comparar
                            </Typography>
                        )}
                    </Grid>
                </Grid>

                <Button type="submit" variant="contained" disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : 'Publicar'}
                </Button>
            </Grid>
        </Grid>
    )
}

export default Formulario_Crear_Proyectos;
